import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { BOARD_COLLECTION_ACTION_BAR } from "~/constants/testIDs";
import { BOARD_COLLECTION_ACTION_BAR_HEIGHT } from "~/constants/WorkspaceSpacing";
import { BoardCollectionDeleteButton } from "./BoardCollectionDeleteButton";
import { BoardCollectionEditButton } from "./BoardCollectionEditButton";
import { BoardCollectionItemsSelected } from "./BoardCollectionItemsSelected";
import { BoardCollectionSelectAllButton } from "./BoardCollectionSelectAllButton";
import { BoardCollectionSubmitButton } from "./BoardCollectionSubmitButton";
import { BoardCollectionUploadMoreButton } from "./BoardCollectionUploadMoreButton";
export const BoardCollectionActionBar = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center bg-white px-3 shadow-popover md:px-6 lg:px-14",
        "data-disableselect": "true",
        "data-testid": BOARD_COLLECTION_ACTION_BAR,
        style: {
            height: BOARD_COLLECTION_ACTION_BAR_HEIGHT
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-1 items-center",
                children: [
                    /*#__PURE__*/ _jsx(BoardCollectionSelectAllButton, {}),
                    /*#__PURE__*/ _jsx(BoardCollectionUploadMoreButton, {}),
                    /*#__PURE__*/ _jsx(BoardCollectionEditButton, {}),
                    /*#__PURE__*/ _jsx(BoardCollectionDeleteButton, {}),
                    /*#__PURE__*/ _jsx("div", {
                        className: "border-l border-l-pigeon-50 px-4",
                        children: /*#__PURE__*/ _jsx(BoardCollectionItemsSelected, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(BoardCollectionSubmitButton, {})
            })
        ]
    });
});
BoardCollectionActionBar.displayName = "BoardCollectionActionBar";
